/**
 * xiaDanUser 首页 — TabBar 容器
 *
 * 翻译自 user/pages/index/index.vue
 *   原结构：
 *     - 两个 <view> 根据 currentIndex 切换显示/隐藏
 *     - 顶部 <RunIndex> 跑腿首页
 *     - 顶部 <UserIndex> 我的
 *     - 底部 <tn-tabbar>
 *
 * 这里用条件渲染 + TabBar 组件实现
 */
"use client";

import { useState } from "react";
import { TabBar } from "@/components/tab-bar";
import RunHomePage from "./run/page";
import MyPage from "./my/page";

export default function HomePage() {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <main className="min-h-screen bg-page-common-bg">
      {/* 跑腿 Tab */}
      <div
        style={{
          display: currentTab === 0 ? "block" : "none",
        }}
      >
        <RunHomePage />
      </div>

      {/* 我的 Tab */}
      <div
        style={{
          display: currentTab === 1 ? "block" : "none",
        }}
      >
        <MyPage />
      </div>

      {/* 底部 TabBar */}
      <TabBar value={currentTab} onChange={setCurrentTab} />
    </main>
  );
}
